<template>
  <div class="content">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div v-if="(onDutyAdmins && onDutyAdmins.length) || (onBreakAdmins && onBreakAdmins.length)">
          <h6 class="hero-heading ml-10 mb-4">Today's Heroes</h6>
          <div :style="`background: linear-gradient(to right, #DEE2ED 0%, #DEE2ED ${getPercentage}%, #fbc65869 75%, #fbc65869 100%)`"  class="card top-cards">
            <div class="row ml-5 pt-10 pb-10 mr-5 card-content mb-0">
              <div :class="getColumnClass()" class="pr-0">
                <span v-for="(row, index) in onDutyAdmins" :key="index">
                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer mb-3" width="20px" :title="row.firstName" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">
                </span>
              </div>
              <div v-if="onBreakAdmins && onBreakAdmins.length > 0" :class="getColForBreakAdmins()" class="text-right pl-0">
                <span v-for="(row, index) in onBreakAdmins" :key="index+'break'">
                  <img :id='row.uid' data-toggle="tooltip" data-placement="top" data-html="true" :key="row.firstName+'break'" class="adminImage make-cursor-pointer mb-3" width="20px" :title="row.firstName" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">
                </span>
              </div>
              <!--              <div class="ml-10 pt-10 pb-10 mr-10">-->
              <!--                <span>-->
              <!--                  <span v-for="(row, index) in activeAdmins" :key="index">-->
              <!--                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer" width="20px" :title="row.firstName" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">-->
              <!--                  <div v-if="index===13" class="mb-10"></div>-->
              <!--                </span>-->
              <!--                </span>-->
              <!--                <span>-->
              <!--                  <span v-for="(row, index) in onBreakAdmins" :key="index+'break'">-->
              <!--                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="adminImage make-cursor-pointer" width="20px" :title="row.firstName" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">-->
              <!--                  <div v-if="index===13" class="mb-10"  ></div>-->
              <!--                </span>-->
              <!--                </span>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>


      <div class="d-flex align-items-center col-lg-6 col-md-6 col-sm-6">
        <div class="card-body">
          <div class="d-flex justify-content-around">
            <span class='text-capitalize' style="font-size: 30px"><strong>Welcome {{ user.firstName }}</strong></span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center col-sm-12 col-md-3 col-lg-3 mt-2">
        <div class="card-transparent">
          <div class="card-head">
            <span class="card-category">
              <div class="d-flex">
                 <button  v-if="attendanceStatus.status==='shift out' && !isOnBreak"  data-toggle="modal"  @click="fixModal" data-target="#getBreakModal" type="button"  class="btn btn-info  btn-sm left" :disabled="disabled">
                    Break <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>
                 </button>
                 <button  v-if="attendanceStatus.status==='shift out' && isOnBreak"  @click="endBreak" type="button"  class="btn btn-warning btn-sm left" :disabled="disabled">
                    End Break  <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>
                 </button>
                <button type="button" :class="`btn ${attendanceStatus.status === 'shift in'? 'btn-success' : 'btn-danger'} btn-sm center left`" @click="clockInOut(attendanceStatus.status)" :disabled="disabled || isOnBreak">
                   {{ attendanceStatus.status }}     <i v-if='adminAttendanceLoading' :class="{'fa fa-refresh': true, 'fa-spin': adminAttendanceLoading}"></i>
                 </button>
              </div>
            </span>
          </div>
          <div class="card-body p-0 m-0 pr-0 mr-0 d-flex justify-content-end">
            <div>
              <div class="d-flex justify-content-center"><span class="time-font"><strong>{{ dateTime }}</strong> <small class="text-muted est-font"> (EST)</small> </span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-2 col-lg-6">
        <Monitors/>
      </div>
      <div class="col-sm-12 col-md-2 col-lg-6">
        <ActiveTask/>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-4">
       <Announcement/>
      </div>
      <div class="col-sm-8 col-md-8 col-lg-8">
        <RecentTicketComments/>
      </div>
      <div class="col-sm-12 col-md-3 col-lg-3 mt-2">
        <RecentActivity/>
      </div>
      <div class="col-sm-12 col-md-3 col-lg-3 mt-2">
        <Todo/>
      </div>
      <div class="col-sm-12 col-md-2 col-lg-6">
        <watchList/>
      </div>

    </div>
    <div class="reminder-modal position-relative">
      <div class="modal fade getBreakModal" id="getBreakModal" tabindex="-1" role="dialog" aria-labelledby="getBreakModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Add Break Time</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form action="" @submit.prevent="submit">

              <div class="modal-body">
                <div class="form-group">
                  <label>Expected time for break to end</label>
                  <select required class="form-control" v-model="formData.due_date">
                    <option v-for="value in breakOptions" :key=value.key :value=value.value >{{ value.key }}</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button class="btn btn-primary" >
                  <div v-if='loading' class="loader small_loader"></div>
                  <span >Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
import Monitors from "@/components/Admin/AdminDashboard/Monitors.vue";
import Announcement from "@/components/Admin/AdminDashboard/Announcement.vue";
import {db} from "@/firebase/init";
import Todo from "@/components/Admin/AdminDashboard/Todo.vue";
import ActiveTask from "@/components/Admin/AdminDashboard/ActiveTask.vue";
import RecentActivity from "@/components/Admin/AdminDashboard/RecentActivity.vue";
import watchList from "@/components/Admin/AdminDashboard/watchList.vue";
import Chat from "@/components/Admin/AdminDashboard/Chat.vue";
import moment from "moment-timezone";
import md5 from "crypto-js/md5";
import RecentTicketComments from "@/components/Admin/AdminDashboard/RecentTicketComments";
export default {
  name: "dashboardUI",
  components: {RecentTicketComments, Announcement , Todo , ActiveTask , RecentActivity, watchList, Chat , Monitors},
  data () {
    return {
      breakOptions:[
        {key: '10 minutes', value: 10},
        {key: '15 minutes', value: 15},
        {key: '30 minutes', value: 30},
        {key: '1 hour', value: 60},
        {key: '1.5 hours', value: 90},
        {key: '2 hour', value: 120},
      ],
      dateTime: null,
      loading: false,
      attendanceStatus: {
        id: '',
        status: 'shift in',
        breaks:[],
      },
      isOnBreak: false,
      activeAdminListener: null,
      currentBreakTime:{
        startTime: '',
        endTime:'',
      },
      activeAdmins: [],
      adminsOnBreak: [],
      disabled: false,
      adminAttendanceLoading: false,
      space: null,
      totalAdmins: [],
      formData: {},
    }
  },
  mounted() {
    this.getAllUserAttendance()
    this.updateDateTime();
    this.timer = setInterval(() => {
      this.updateDateTime();
    }, 1000);

  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    getPercentage() {
      let percentage = 100
      if (this.onBreakAdmins && this.onBreakAdmins.length === 1) {
        percentage = 87
      } else if (this.onBreakAdmins && this.onBreakAdmins.length === 2) {
        percentage = 80
      } else if(this.onBreakAdmins && this.onBreakAdmins.length >= 3) {
        percentage = 75
      }
      return percentage
    },
    onBreakAdmins() {
      return this.activeAdmins.filter(el => el.breaks && el.breaks.length && !el.breaks[el.breaks.length - 1].endTime) || []
    },
    onDutyAdmins() {
      return this.activeAdmins.filter(el => el.status && ((el.breaks && el.breaks.length && el.breaks[el.breaks.length - 1].endTime) || el.breaks.length===0) )
    },
    user() {
      return this.$store.getters.user;
    },
  },
  destroyed() {
    this.activeAdminListener();
  },
  methods: {
    getColumnClass(){
      if(this.onBreakAdmins && this.onBreakAdmins.length > 0) {
        return this.onBreakAdmins.length === 1 ? 'col-md-10' : 'col-md-9'
      }
      return 'col-md-12'
    },
    getColForBreakAdmins() {
      if(this.onBreakAdmins && this.onBreakAdmins.length > 0) {
        return this.onBreakAdmins.length === 1 ? 'col-md-2' : 'col-md-3'
      }
    },
    async endBreak(){
      try{
        this.currentBreakTime.endTime = new Date().toISOString();
        this.attendanceStatus.breaks[this.attendanceStatus.breaks.length-1].endTime= this.currentBreakTime.endTime;
        await db.collection('attendance').doc(this.attendanceStatus.id).update({
          breaks: this.attendanceStatus.breaks
        })
        const blocks = [
          {
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": `:back: ${this.user.firstName} ${this.user.lastName} is back from break!`,
                "emoji": true
              }
            ]
          }
        ]
        await this.$http.post('/slack/send_slack_message', {
          blocks,
          type: 'teamchat',
          grant_type: 'token'
        })
      }
       catch(e){
        console.log(e.toString(), 'Error Occurred in ending break')
       }
       finally {
        this.isOnBreak = false;
      }
      },
    // checkBreakExist(){
    //   if(this.attendanceStatus.breaks.length === 0 ){
    //     this.isOnBreak  = false;
    //     return
    //   }
    //   const result =this.attendanceStatus.breaks.find((value)=>  value.startTime && value.endTime === '')
    //   if(result=== undefined){
    //     this.isOnBreak= false;
    //     return
    //   }
    //   this.isOnBreak=true;
    //   this.attendanceStatus.startTime=result.startTime;
    // },
    async submit(){
      try{
        let now = new Date();
        // now.setMinutes(now.getMinutes() + this.formData.due_date);
        // const localTime = now.toISOString();
        this.adminAttendanceLoading=true;
        this.currentBreakTime.startTime =new Date().toISOString()
        this.currentBreakTime.time = this.formData.due_date
        this.currentBreakTime.endTime='';
        this.attendanceStatus.breaks.push({...this.currentBreakTime});
        await db.collection('attendance').doc(this.attendanceStatus.id).update({
          breaks: this.attendanceStatus.breaks
        })
        const easternTime = now.toLocaleString('en-US', {
          timeZone: 'America/New_York',
        });
        let finalDate = moment(easternTime).format("MMMM Do YYYY, h:mm a")
        const blocks = [
          {
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": `:double_vertical_bar: ${this.user.firstName} ${this.user.lastName} is on break for ${this.formData.due_date} minutes.`,
                "emoji": true
              }
            ]
          }
        ]
        await this.$http.post('/slack/send_slack_message', {
          blocks,
          type: 'teamchat',
          grant_type: 'token'
        })
        this.isOnBreak = true
        $('#getBreakModal').modal('hide');
      }
       catch (e){
        console.log(e.toString(), 'Error occurred in adding start time')
       }
       finally {
        this.adminAttendanceLoading=false;
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        // this.checkBreakExist()
      }
    },
    fixModal() {
      /* eslint-disable */
      this.loading=false
      this.formData={}
      this.formData.due_date= 10
      $('.modal-backdrop').removeClass("getBreakModal");

    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    setCheckinStatus(id, data , isOnBreak , isLogOut = false ){
      if(isLogOut){
        this.attendanceStatus.status= 'shift in'
        this.adminAttendanceLoading =false
        return
      }
      if(isOnBreak){
        this.attendanceStatus.breaks = data.breaks;
        this.isOnBreak = true
        return
      }

      this.isOnBreak= false;
      this.attendanceStatus.breaks = data.breaks;
      return
    },
    async getAllUserAttendance(){
      try{
        const ref= await db.collection('attendance')
        this.activeAdminListener = ref.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added'){
             if(changeDoc.doc.data().status){
               console.log(changeDoc)
               this.activeAdmins.push({id: changeDoc.doc.id , ...changeDoc.doc.data()})
               if(changeDoc.doc.data().userUid === this.user.uid){
                 this.attendanceStatus.id= changeDoc.doc.id
                 this.attendanceStatus.status= 'shift out'
                 this.attendanceStatus.breaks =  changeDoc.doc.data().breaks === undefined ? []: changeDoc.doc.data().breaks;
                 if (this.attendanceStatus.breaks && this.attendanceStatus.breaks.length) {
                   this.isOnBreak = !this.attendanceStatus.breaks[this.attendanceStatus.breaks.length - 1].endTime ? true : false;
                 }
                 this.adminAttendanceLoading = false
               }
             }
            }
            else if(changeDoc.type === 'modified') {
              let data = changeDoc.doc.data();
              // this means shift out
              const obj = this.activeAdmins.find(el => el.id === changeDoc.doc.id);
              if (obj) {
                obj.breaks = data.breaks
              }
              if (data.status === false && data.checkOutTime) {
                this.activeAdmins = this.activeAdmins.filter((value) => value.id !== changeDoc.doc.id)
                // this.adminsOnBreak= this.adminsOnBreak.filter((value)=>value.id !== changeDoc.doc.id)
                // this.totalAdmins= this.totalAdmins.filter((value)=>value.id !== changeDoc.doc.id)

                if (data.userUid === this.user.uid) {
                  console.log('I got called while log out');
                  this.setCheckinStatus(changeDoc.doc.id, data, false, true)
                }
              }
              // this means change is about break end
              else if (data.breaks.length > 0 && data.breaks[data.breaks.length - 1].endTime) {
                // this.adminsOnBreak= this.adminsOnBreak.filter((value)=>value.id !== changeDoc.doc.id)
                // this.activeAdmins.push({id: changeDoc.doc.id , ...changeDoc.doc.data()})

                if (data.userUid === this.user.uid) {
                  this.setCheckinStatus(changeDoc.doc.id, data, false)
                }
              }
              // this means break starts
              else if (data.breaks.length > 0 && !data.breaks[data.breaks.length - 1].endTime) {
                // this.adminsOnBreak.push({id: changeDoc.doc.id , ...changeDoc.doc.data()})
                // this.activeAdmins= this.activeAdmins.filter((value)=>value.id !== changeDoc.doc.id)
                if (data.userUid === this.user.uid) {
                  this.setCheckinStatus(changeDoc.doc.id, data, true)
                }
              }
          }
            console.log('active admins', this.activeAdmins)
            $(function () {
              $('[data-toggle="tooltip"]').tooltip()
            })
        })});
      }
      catch(e){
        console.log(e.toString(), 'Error in fetching all admins attendance')
      }
      finally {
      }

    },
    async getCheckinStatus(){
      try{
        this.isOnBreak = false;
        const ref= await db.collection('attendance').where('userUid', '==', this.user.uid).where('status' , '==', true).get()
        if(ref.empty){
          this.attendanceStatus.status='shift in'
          return
        }
          ref.docs.forEach((value)=>{
            console.log('this value', value.id)
            this.attendanceStatus.id= value.id;
            this.attendanceStatus.status= 'shift out'
            this.attendanceStatus.breaks =  value.data().breaks === undefined ? []: value.data().breaks;
            if (this.attendanceStatus.breaks && this.attendanceStatus.breaks.length) {
              this.isOnBreak = !this.attendanceStatus.breaks[this.attendanceStatus.breaks.length - 1].endTime ? true : false;
            }
          });
      }
      catch(e){
      console.log(e.toString(), 'Could not fetch attendance')
      }
      finally {
        // this.isOnBreak = false;
        // this.checkBreakExist()
        this.adminAttendanceLoading=false;
      }
    },
    async clockInOut(value){
      this.disabled= true;
      this.adminAttendanceLoading=true;
      try{
        let blocks = [];
        if(value==='shift in'){
         const ref= await db.collection('attendance').add({
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
            userUid: this.user.uid,
            checkInTime: new Date().toISOString(),
            createdAt: new Date().toISOString(),
            breaks: [],
            status: true,
          })
          blocks = [
            {
              "type": "context",
              "elements": [
                {
                  "type": "plain_text",
                  "text": `:wave: ${this.user.firstName} ${this.user.lastName} has signed into their shift.`,
                  "emoji": true
                }
              ]
            }
          ]
          await this.$http.post('/slack/send_slack_message', {
            blocks,
            type: 'teamchat',
            grant_type: 'token'
          })
          this.attendanceStatus.id =ref.id;
          this.attendanceStatus.status='shift out'
        }
        else {
          await db.collection('attendance').doc(this.attendanceStatus.id).update({
            checkOutTime: new Date().toISOString(),
            status: false,
          })
          blocks = [
            {
              "type": "context",
              "elements": [
                {
                  "type": "plain_text",
                  "text": `:clock12: ${this.user.firstName} ${this.user.lastName} has signed out of their shift.`,
                  "emoji": true
                }
              ]
            }
          ]
          await this.$http.post('/slack/send_slack_message', {
            blocks,
            type: 'teamchat',
            grant_type: 'token'
          })
          this.attendanceStatus.status= 'shift in'
        }
      }
      catch(e){
        console.log(e.toString(), `Error in ${value} attendance`)
      }
      finally {
       this.disabled=false;
       this.isOnBreak = false;
        // this.checkBreakExist()
        this.adminAttendanceLoading=false;
      }
    },
    updateDateTime(){
      let now = new Date();
      const easternTime = now.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let finalDate=moment(easternTime).format("HH:mm")
      this.dateTime=finalDate;
    }
  }

};
</script>

<style scoped>
.hero-heading{
  padding: 0;
  margin: 0;
}
.top-cards{
  border-radius: 40px;
}
.adminImage{
  border-radius: 50%;
  margin: 0px 3px 0px 3px;
}
.image-container img {
  width: 15%;
}
.time-font{
  font-size : 35px;
  font-family: 'Orbitron';
}
.est-font{
  font-size: 15px
}
</style>
